import { render, staticRenderFns } from "./CampaignsTable.vue?vue&type=template&id=50fb1d1e&scoped=true&"
import script from "./CampaignsTable.vue?vue&type=script&lang=js&"
export * from "./CampaignsTable.vue?vue&type=script&lang=js&"
import style0 from "./CampaignsTable.vue?vue&type=style&index=0&id=50fb1d1e&lang=scss&scoped=true&"
import style1 from "./CampaignsTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fb1d1e",
  null
  
)

export default component.exports